/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * ErrorNotification CSS
 */
export const styles = css`
  :host {
    --indication-color: var(--nile-colors-red-700, var(--ng-colors-text-error-primary-600));
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  .nile-error-notification {
    font-family: var(--nile-font-family-serif, var(--ng-font-family-body));
    font-size: var(--nile-type-scale-2, var(--ng-font-size-text-xs));
    font-style: normal;
    font-weight: var(--nile-font-weight-regular, var(--ng-font-weight-regular));
    line-height: var(--nile-line-height-xsmall, var(--ng-line-height-text-xs));
    letter-spacing: 0.2px;
    border: 1px solid var(--indication-color);
    border-left: var(--nile-border-size-6, var(--ng-border-width-4)) solid var(--indication-color);
    border-radius: var(--nile-radius-radius-xs, var(--ng-radius-xs));
    padding: var(--nile-spacing-md, var(--ng-spacing-md));
    background: var(--nile-colors-neutral-100, var(--ng-colors-bg-primary));
    color: var(--indication-color);
    box-sizing: border-box;
  }

  .nile-error-notification__icon {
    vertical-align: middle;
    margin-right: var(--nile-spacing-xs, var(--ng-spacing-xxs));
  }
`;

export default [styles];
